import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SettingsHttpService } from 'app/features/settings/services/settings.service';
import { catchError, exhaustMap, map, of } from 'rxjs';
import { ServiceCenter } from 'app/features/settings/models/service-center.model';
import { SC_ACTIONS } from '.';

@Injectable()
export class ServiceCenterEffects {
  loadServiceCenters$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SC_ACTIONS.triggerServiceCenters),
      exhaustMap(() =>
        this.settingsService.getServiceCenters().pipe(
          map((serviceCenters: ServiceCenter[]) =>
            SC_ACTIONS.serviceCentersSuccess({ serviceCenters })
          ),
          catchError(error => of(SC_ACTIONS.serviceCentersFailure({ error: error.message })))
        )
      )
    );
  });

  constructor(
    private actions$: Actions,
    private settingsService: SettingsHttpService
  ) {}
}
